"use client"

import TopHeaderClient from "./TopHeaderClient"
import type { UserSession } from "@/types/session"
import { ClientProviders } from "@/app/providers"
import { HeaderTranslations } from "@/app/hooks/useTranslation"

export default function SessionWrapper({ session, translations }: { session: UserSession | null, translations: HeaderTranslations }) {
  return (
    <ClientProviders session={session}>
      <TopHeaderClient messages={translations} />
    </ClientProviders>
  )
}
